
'use client';
import Image from 'next/image';

const speakers = [
  {
    name: "Hadir Gaber",
    designation: "Founder & CEO",
    company: "ChainMena",
    imageSrc: "/images/speakers/hadir-gaber.webp",
    alt: "hadir-gaber",
  }, 
  {						
    name: "Illia Pashkov",
    designation: "Founder",
    company: "SINT",
    imageSrc: "/images/speakers/illia-pashkov.webp",
    alt: "illia-pashkov",
  }, 
  {
    name: "Oleh Bevz",
    designation: "Co-Founder",
    company: "INPUT Global",
    imageSrc: "/images/speakers/oleg-bevz-new.webp",
    alt: "oleg-bevz",
  }, 
  // end 2025 speakers
  {
    name: "Jake",
    designation: "Founder",
    company: "Magnet",
    imageSrc: "/images/speakers/jake-speaker.webp",
    alt: "Jake",
  }, 
  {
    name: "Ryuzaki",
    designation: "Ambassador, DAO Council Member",
    company: "Decentraland",
    imageSrc: "/images/speakers/ryuzaki-speaker.webp",
    alt: "ryuzaki",
  },
  {
    name: "Sujal Jethwani",
    designation: "Co-founder & CEO",
    company: "GrowRex",
    imageSrc: "/images/speakers/sujalJethwani.webp",
    alt: "sujalJethwani",
  }, 
   {
    name: "Lionel Williams",
    designation: "VP",
    company: "Light Node Ventures",
    imageSrc: "/images/speakers/lionel-williams-s.webp",
    alt: "Lionel-Williams",
  },

];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.tsx:61:4" data-component-path="src/app/SpeakerSection.tsx" data-component-line="61" data-component-end-line="100" data-component-file="SpeakerSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%20bg-white%22%7D" id='speakers'
      className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4 bg-white"
    >
      <div data-component-id="src/app/SpeakerSection.tsx:64:6" data-component-path="src/app/SpeakerSection.tsx" data-component-line="64" data-component-end-line="99" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.tsx:66:8" data-component-path="src/app/SpeakerSection.tsx" data-component-line="66" data-component-end-line="68" data-component-file="SpeakerSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20mb-10%20text-center%20sm%3Atext-%5B32px%5D%20md%3Atext-%5B36px%5D%20lg%3Atext-%5B42px%5D%20font-semibold%20text-text-muted%20font-%5B'%5D%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[28px] mb-10 text-center sm:text-[32px] md:text-[36px] lg:text-[42px] font-semibold text-text-muted font-[']">
             Past Speakers
            </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.tsx:70:8" data-component-path="src/app/SpeakerSection.tsx" data-component-line="70" data-component-end-line="98" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full  max-w-[1200px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.tsx:72:10" data-component-path="src/app/SpeakerSection.tsx" data-component-line="72" data-component-end-line="97" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-5%20sm%3Agap-6%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.tsx:74:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="74" data-component-end-line="95" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.tsx:76:16" data-component-path="src/app/SpeakerSection.tsx" data-component-line="76" data-component-end-line="85" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.tsx:77:18" data-component-path="src/app/SpeakerSection.tsx" data-component-line="77" data-component-end-line="84" data-component-file="SpeakerSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%20object-cover%20w-full%20h-full%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    width={250}
                    height={250}
                    unoptimized
                    className="rounded-full object-cover w-full h-full"
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.tsx:86:16" data-component-path="src/app/SpeakerSection.tsx" data-component-line="86" data-component-end-line="88" data-component-file="SpeakerSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23ff00b6%5D%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20text-center%20mb-1%20font-semibold%20text-text-light%20font-%5B'%5D%22%7D" className="text-[#ff00b6] text-[13px] sm:text-[18px] text-center mb-1 font-semibold text-text-light font-[']">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.tsx:89:16" data-component-path="src/app/SpeakerSection.tsx" data-component-line="89" data-component-end-line="91" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%23000%5D%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%20font-%5B'%5D%22%7D" className="text-[#000] text-[12px] sm:text-[14px] text-center mb-1 font-[']">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.tsx:92:16" data-component-path="src/app/SpeakerSection.tsx" data-component-line="92" data-component-end-line="94" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%23000%5D%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%20font-%5B'%5D%22%7D" className="text-[#000] text-[10px] sm:text-[12px] text-center font-[']">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
